import { Link as LinkIcon, Plus, X } from 'lucide-react'

export default function CardDependenciesTab({
    t,
    canCreate,
    addingDependency,
    setAddingDependency,
    dependType,
    setDependType,
    dependTargetId,
    setDependTargetId,
    allCards,
    cardId,
    addingDepLoading,
    onAddDependency,
    dependencies,
    isAdmin,
    removeDependency,
}) {
    return (
        <div>
            <div className="cd-tab-header">
                <h4 className="cd-tab-title">{t('card.dependencies.heading')}</h4>
                {canCreate && (
                    <button
                        className="btn btn-secondary btn-sm"
                        onClick={() => setAddingDependency(!addingDependency)}
                    >
                        <Plus size={13} /> {t('card.dependencies.link')}
                    </button>
                )}
            </div>

            {addingDependency && (
                <div className="card-detail-section cd-dep-form">
                    <div className="cd-dep-form-row">
                        <select
                            className="inline-input cd-dep-inline-select"
                            value={dependType}
                            onChange={(event) => setDependType(event.target.value)}
                        >
                            <option value="blocks">{t('card.dependencies.blocksOption')}</option>
                            <option value="is_blocked_by">{t('card.dependencies.isBlockedByOption')}</option>
                        </select>
                        <span className="cd-dep-inline-label">{t('card.dependencies.theCard')}</span>
                    </div>
                    <div className="cd-dep-form-row">
                        <select
                            className="inline-input cd-dep-inline-select"
                            value={dependTargetId}
                            onChange={(event) => setDependTargetId(event.target.value)}
                        >
                            <option value="">{t('card.dependencies.pickCard')}</option>
                            {allCards.filter((candidate) => candidate.id !== cardId).map((candidate) => (
                                <option key={candidate.id} value={candidate.id}>
                                    {candidate.title}
                                </option>
                            ))}
                        </select>
                        <button
                            className="btn btn-primary btn-sm"
                            disabled={!dependTargetId || addingDepLoading}
                            onClick={onAddDependency}
                        >
                            {addingDepLoading ? t('card.dependencies.adding') : t('card.dependencies.addAction')}
                        </button>
                    </div>
                    <p className="cd-dep-form-hint">
                        {t('card.dependencies.hint')}
                    </p>
                </div>
            )}

            <div className="cd-dep-list">
                {dependencies.map((dep) => {
                    const isBlocker = (dep.direction === 'blocks' && dep.type === 'blocks')
                        || (dep.direction === 'is_blocked_by' && dep.type === 'is_blocked_by')
                    const labelText = isBlocker ? t('card.dependencies.blockerLabel') : t('card.dependencies.waitingLabel')

                    return (
                        <div key={dep.id} className="cd-dep-item">
                            <div className="cd-dep-item-left">
                                <span className={`cd-dep-badge ${isBlocker ? 'blocker' : 'blocked'}`}>
                                    {labelText}
                                </span>
                                <span className={`cd-dep-title ${dep.linked_card?.is_completed ? 'completed' : ''}`}>
                                    {dep.linked_card?.title || t('card.dependencies.unknownCard')}
                                </span>
                            </div>
                            {isAdmin && (
                                <button className="btn-icon-small cd-dep-remove" onClick={() => removeDependency(dep.id)}>
                                    <X size={14} />
                                </button>
                            )}
                        </div>
                    )
                })}
                {dependencies.length === 0 && !addingDependency && (
                    <div className="card-empty-tab">
                        <LinkIcon size={32} />
                        <p>{t('card.dependencies.empty')}</p>
                    </div>
                )}
            </div>
        </div>
    )
}
